import FooterSection from "../../app/hero-gateway/components/FooterSection";

export default FooterSection;
